import * as React from 'react'
import { Block } from '$views/components/Layout/Block'
import { Media } from '$views/components/Media'
import { Text } from '$views/components/Text'
import { Icon } from '$views/components/Icon'
import { Division } from '$views/components/Division'
import styled from 'styled-components'
import rightArrow from '$icons/rightArrow.svg'
import { rem } from 'polished'
import crossIcon from '$icons/cross.svg'
import checkboxIcon from '$icons/checkbox.svg'
import { TextFontWeight } from '$utils/theme/font'
import { css } from '$utils/theme'

interface Props extends React.ButtonHTMLAttributes<any> {
  className?: string
  label?: string
  description?: string
  descriptionIcon?: boolean
  descriptionColor?: string
  onClick?: any
  avanzarIcon?: string
  completed?: boolean
  visible?: boolean
  weight?: TextFontWeight
  noPaddingTop?: boolean
  title?: string
  boldLabel?: string
  alignItems?: 'center' | 'start' | 'end' | 'baseline'
  disabled?: boolean
}

const AvanzarButton = styled.button<Props>`
  border: none;
  width: 100%;
  background-color: transparent;
  text-align: left;
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};

  padding-top: ${p => rem(p.theme.sizes.small)};
  ${p =>
    p.noPaddingTop &&
    css`
      padding-top: ${rem(p.theme.sizes.none)};
    `}
  padding-right: ${p => rem(p.theme.sizes.none)};
  padding-left: ${p => rem(p.theme.sizes.none)};

  &:focus {
    outline: none;
  }
`

export const Avanzar: React.SFC<Props> = ({
  label,
  description,
  descriptionIcon,
  descriptionColor,
  completed,
  noPaddingTop,
  title,
  boldLabel,
  alignItems,
  disabled,
  ...props
}) => {
  const icon = completed ? checkboxIcon : crossIcon
  const mediaColor = disabled ? 'grey' : 'darkgrey'
  const onClickButton = () => {
    if (!disabled) {
      props.onClick()
    }
  }

  return (
    <AvanzarButton type="button" onClick={onClickButton} noPaddingTop={noPaddingTop} disabled={disabled}>
      {title && (
        <Text menu weight="medium" marginBottom="base">
          {title}
        </Text>
      )}
      <Media
        boldLabel={boldLabel}
        label={label}
        urlIcon={props.avanzarIcon ? props.avanzarIcon : rightArrow}
        size="m"
        weight={props.weight}
        alignItems={alignItems}
        color={mediaColor}
      />
      <Block>
        {descriptionIcon && <Icon content={icon} size="s" color={descriptionColor} marginRight="base" />}
        <Text as="span" color={descriptionColor}>
          {description}
        </Text>
      </Block>
      {!!props.visible && <Division color="lightGrey" marginTop="small" />}
    </AvanzarButton>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Navegacion/Avanzar/Avanzar.tsx